import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { mapDispatchToProps, mapStateToProps } from "../../../utils/config";

/**
 * Guarda de rota para as telas restritas a administrador.
 *
 * O menu ja esconde "Gerenciamento" e "Relatorios" de quem nao e admin
 * (SideBar/index.js), mas esconder link nao e proteger rota: bastava digitar
 * /gerenciamento na barra de enderecos para a tela abrir.
 *
 * Nao havia como causar dano -- o BACKEND ja exige administrador
 * (AuthValidation.adminValidation nas rotas de gerenciamento e
 * UsuarioEdicaoValidation no /usuarios), entao os cards voltavam vazios ou com
 * erro. Era exposicao de interface, nao furo de dados. Ainda assim, a tela nao
 * deveria abrir.
 */
function RotaAdministrador({ usuario, children }) {
  // O Routes.js busca o usuario de forma assincrona; ate a resposta chegar, o
  // estado inicial do redux e Usuario.model, que NAO tem id nem tipo. Redirecionar
  // nesse instante expulsaria o proprio administrador a cada F5.
  if (!usuario?.id) return null;

  if (usuario.tipo !== "Administrador") return <Navigate to="/plantar" replace />;

  return children;
}

export default connect(mapStateToProps, mapDispatchToProps)(RotaAdministrador);
